import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  IParentEventQueryParams,
  IParentEventResponse,
} from '../../interface/parentEvent.interface';
import { IErrorResponse } from '../../interface/main.interface';
import { parentEventService } from '../../services/parentEvent';
import { normalizeAxiosError } from '../../utility/axiosErrorHandler';

export const fetchParentEvents = createAsyncThunk<
  IParentEventResponse,
  { studentId: string; params?: IParentEventQueryParams },
  { rejectValue: IErrorResponse }
>('parentEvent/fetch', async ({ studentId, params }, { rejectWithValue }) => {
  try {
    const response = await parentEventService.fetchParentEvents(studentId, params);
    return response.data;
  } catch (err) {
    return rejectWithValue(normalizeAxiosError(err, 'Failed to fetch events.'));
  }
});

export const parentEventActions = {
  fetchParentEvents,
};
